

















































import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
import { Enterprise, EnterpriseModel } from '@/resources/enterprise/Enterprise';
import { Product } from '@/store/types/public/products/Product';
import Pagination from '@/components/Pagination.vue';
import { Watch } from 'vue-property-decorator';
import { NAMESPACE } from '@/store/models/pub/products';
import { namespace } from 'vuex-class';
import { GET_ITEM, LOADING, SHOW_REQUEST } from '@/store';

const store = namespace(NAMESPACE);

@Component({
  components: { Pagination, PublicLayout }
})
export default class EnterpriseProduct extends Mixins<SlotMixin>(SlotMixin) {
  @store.Getter(GET_ITEM) product!: Product;
  @store.Getter(LOADING) loading!: boolean;
  @store.Action(SHOW_REQUEST) getProduct!:any;

  @Watch('$route.params.product', { deep: true })
  onProductChanged (newVal:number) {
    this.getProduct(newVal);
  }

  created () {
    this.getProduct(parseInt(this.$route.params.product));
    this.$gtag.event('page_view', { screen_name: 'Перегляд деталей товару' });
  }
}
